/* eslint-disable no-shadow */
const state = {
  loginStatus: false,
  courseStatus: false,
  userData: Object,
  payment: {},
  userRole: String,
  wishlist: [],
  courses: {
    subscribedCourses: [],
    subscribedLiveCourses: [],
    teacherCourses: [],
    teacherLiveCourses: {}
  },
  teacherSubscription: {},
  followingStudents: []
};

const getters = {
  isAuthenticated: state => state.loginStatus,
  getCourseStatus: state => state.courseStatus,
  getUserDetails: state => state.userData,
  getPaymentDetails: state => state.payment,
  getUserRole: state => state.userRole,
  getWishlist: state => state.wishlist,
  getSubscribedCourses: state => state.courses.subscribedCourses,
  getSubscribedLiveCourses: state => state.courses.subscribedLiveCourses,
  getTeacherCourses: state => state.courses.teacherCourses,
  getTeacherLiveCourses: state => state.courses.teacherLiveCourses,
  getTeacherSubscriptions: state => state.teacherSubscription,
  getFollowingStudents: state => state.followingStudents
};

const mutations = {
  setLoginStatusMutation: (state, payload) => {
    state.loginStatus = payload;
  },
  setUserDataMutation: (state, payload) => {
    state.userData = payload;
  },
  clearUserDetailsMutation: state => {
    state.userData = {};
    state.loginStatus = false;
    state.courseStatus = false;
    state.payment = {};
    state.userRole = "";
    state.wishlist = [];
    state.followingStudents = [];
    state.courses.subscribedCourses = [];
    state.courses.subscribedLiveCourses = [];
    state.courses.teacherCourses = [];
    state.courses.teacherLiveCourses = {};
    state.teacherSubscription = {};
  },
  setPaymentDetailsMutation: (state, payload) => {
    state.payment = payload;
  },
  setUserRoleMutation: (state, payload) => {
    state.userRole = payload;
  },
  setWishlistMutation: (state, payload) => {
    state.wishlist = payload;
  },
  setSubscribedCoursesMutation: (state, payload) => {
    state.courses.subscribedCourses = payload;
  },
  setSubscribedLiveCoursesMutation: (state, payload) => {
    state.courses.subscribedLiveCourses = payload;
  },
  setTeacherCoursesMutation: (state, payload) => {
    state.courses.teacherCourses = payload;
  },
  setTeacherLiveCoursesMutation: (state, payload) => {
    state.courses.teacherLiveCourses = payload;
  },
  setCourseStatusMutation: (state, payload) => {
    state.courseStatus = payload;
  },
  setTeacherSubscriptionMutation: (state, payload) => {
    state.teacherSubscription = payload;
  },
  setFollowingStudentsMutation: (state, payload) => {
    state.followingStudents = payload;
  }
};

const actions = {
  setLoginStatus: ({ commit }, payload) => {
    commit("setLoginStatusMutation", payload);
  },
  setUserData: ({ commit }, payload) => {
    commit("setUserDataMutation", payload);
  },
  clearUserData: ({ commit }) => {
    commit("clearUserDetailsMutation");
  },
  setPaymentDetails: ({ commit }, payload) => {
    commit("setPaymentDetailsMutation", payload);
  },
  setUserRole: ({ commit }, payload) => {
    commit("setUserRoleMutation", payload);
  },
  setWishlist: ({ commit }, payload) => {
    commit("setWishlistMutation", payload);
  },
  setSubscribedCourses: ({ commit }, payload) => {
    commit("setSubscribedCoursesMutation", payload);
  },
  setSubscribedLiveCourses: ({ commit }, payload) => {
    commit("setSubscribedLiveCoursesMutation", payload);
  },
  setTeacherCourses: ({ commit }, payload) => {
    commit("setTeacherCoursesMutation", payload);
  },
  setTeacherLiveCourses: ({ commit }, payload) => {
    commit("setTeacherLiveCoursesMutation", payload);
  },
  setCourseStatus: ({ commit }, payload) => {
    commit("setCourseStatusMutation", payload);
  },
  setTeacherSubscription: ({ commit }, payload) => {
    commit("setTeacherSubscriptionMutation", payload);
  },
  setFollowingStudents: ({ commit }, payload) => {
    commit("setFollowingStudentsMutation", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
